module.exports = __webpack_public_path__ + "static/media/tv-show-asset2.279b0347.svg";